export class UserFeedback {
    feedbackId: string =  "";
    feedbackDateTime?: Date;
    userEmail: string ="";
    feedbackScore: number = 0;
    feedbackComments: string = "";
}